import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { style: {"margin":"10px 0 5px 0"} }, "Контейнеры", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueGrid = _resolveComponent("CatalogueGrid")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_CatalogueGrid, {
      summaryConfig: _ctx.summaryConfig,
      controller: 'PlanTransportContainer',
      columns: _ctx.columns,
      filterRowVisible: false,
      groupPanelVisible: false,
      headerFilterVisible: false,
      filterPanelVisible: false,
      showPageSizeSelector: !_ctx.selectMode,
      pageSize: 10,
      pageSizes: _ctx.pageSizes,
      editingConfig: _ctx.editingConfig,
      selectionConfig: _ctx.selectionConfig,
      designConfig: _ctx.designConfig,
      getSelectedData: _ctx.getSelectedData,
      changeSelectedData: _ctx.changeSelectedData,
      parentModel: _ctx.parentModel,
      popupCreateEditComponent: _ctx.planTransportContainerCreateEditDialog,
      selectMode: _ctx.selectMode,
      ref: "grid"
    }, null, 8, ["summaryConfig", "columns", "showPageSizeSelector", "pageSizes", "editingConfig", "selectionConfig", "designConfig", "getSelectedData", "changeSelectedData", "parentModel", "popupCreateEditComponent", "selectMode"])
  ]))
}